export default "__VITE_ASSET__7d06dc28__"